import { Avatar, Box, Typography } from '@mui/material'
import styles from '../DashBordCards/WelComeCard.module.scss'
import { useState, useEffect } from 'react';

const useCountdown = (targetDate) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(targetDate) - new Date();

      if (difference <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    };

    // Update immediately
    setTimeLeft(calculateTimeLeft());

    // Then update every second
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return timeLeft;
};

export default function WelComeCard({
  text,
  image,
  image2,
  alt1,
  alt2,
  kazooDate = null,
  title = 'Days Until Your Wedding',
  hasTimer = true,
}) {
  // If kazooDate is provided, use it; otherwise, use a default date
  const weddingDate = kazooDate || new Date(Date.now() + 25 * 24 * 60 * 60 * 1000);
  const timeLeft = useCountdown(weddingDate);

  const countdownList = [
    { number: timeLeft.days, label: 'Days' },
    { number: timeLeft.hours, label: 'Hours' },
    { number: timeLeft.minutes, label: 'Minutes' },
    { number: timeLeft.seconds, label: 'Seconds' },
  ];

  // Format the wedding date for display
  const formatWeddingDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (e) {
      console.error('Error formatting date:', e);
      return '';
    }
  };
	return (
		<Box className={styles.WelComeCardWrp}>
			<Box className={styles.WelComeCard}>
				<Box className={styles.WelComeCardText}>
					<Typography variant="span">Welcome</Typography>
					<Typography variant="h2">{text}!</Typography>
					{hasTimer && (
						<div className={styles.WelComeCardTimer}>
							<div className={styles.timerText}>
								<Typography variant="span">
									Wedding Date
								</Typography>
								<Typography variant="h6">
									{formatWeddingDate(weddingDate)}
								</Typography>
							</div>
						</div>
					)}
				</Box>
				<Box className={styles.WelComeCardImage}>
					<Avatar className={styles.img} src={image} alt={alt1} />
					<Avatar className={styles.img} src={image2} alt={alt2} />
				</Box>
			</Box>
			{hasTimer && (
				<div className={styles.countdownWrp}>
					<div className={styles.countdown}>
						<div className={styles.countdownLeft}>
							<img src="/images/timer-icon.svg" alt="countdown" />
							<Typography variant="span">
								{title}
							</Typography>
						</div>
						<div className={styles.countdownRight}>
							<ul className={styles.countdownList}>
								{countdownList.map((data, i) => {
									return (
										<li key={`${data.label}-${i}`}>
											<Typography
												variant="h2"
												className={styles.number}
											>
												{data.number}
											</Typography>
											<Typography
												variant="span"
												className={styles.day}
											>
												{data.label}
											</Typography>
										</li>
									)
								})}
							</ul>
						</div>
					</div>
				</div>
			)}
		</Box>
	)
}
